import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Tr, Td, Button, Text, Flex, Icon, IconButton } from '@chakra-ui/react';
import { MdAttachMoney, MdCurrencyExchange, MdMoney, MdPayment, MdRefresh, MdStar } from 'react-icons/md';
import { AddIcon, LinkIcon, ViewIcon } from "@chakra-ui/icons";
import { Transaction } from '../../store/page/types';
// import { 
//   toggleViewTransactionModal, 
//   selectTransaction, 
// } from '../../store/transactions/actions';
import { ReduxState } from '../../store/state';
// import webUi from '../../apis/webUi';
// import { asyncGeneratePaymentLink } from '../../store/orders/initiators';

const allowedStatusTypes = [
  'pending',
  'completed',
  'failed'
];

function shortenUuid(uuidStr: string, length: number = 8): string {
  // Convert the UUID string to lowercase
  uuidStr = uuidStr.toLowerCase();
  // Remove hyphens from the UUID
  uuidStr = uuidStr.replace(/-/g, '');
  // Return the first 'length' characters
  return uuidStr.slice(0, length);
}

interface TransactionRowProps {
    transaction: Transaction;

}

class TransactionRow extends React.Component<TransactionRowProps> {


  formatCurrency = (currency: string, amount: number) => {
    if (!currency) {
      return amount
    }
    if (currency === 'RWP') {
      return amount.toFixed(0)
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  }

  
  render() {
    const { transaction } = this.props;
    const timestamp = moment(new Date(transaction.timestamp)).format(`MMM D h:mm a`);
    const { notes } = transaction.data;
    let notesDisplay = '';
    if (notes) {
      if (notes.length > 20) {
        notesDisplay = `${notes.slice(0,20)}...`
      } else {
        notesDisplay = notes
      }
    }

    console.log(transaction)
    return (
      <Tr key={transaction._id} style={{ background: 'white' }} boxShadow="0 2px 8px rgba(0, 0, 0, 0.2)">
        <Td>
          <Button size={'xs'} leftIcon={<MdCurrencyExchange />} borderRadius={'full'} >
            <Text>{shortenUuid(transaction._id)}</Text>
          </Button>
        </Td>
        <Td>
          <Text fontSize='sm' color='gray.600'>{timestamp}</Text>
        </Td>
        <Td>
          <Button variant={'outline'} size={'xs'} colorScheme={transaction.type === 'payment' || transaction.type === 'partner commission' ? 'green' : 'gray'}>{transaction.type}</Button>
        </Td>
        <Td>
          <Text fontSize='sm' color='gray.600' textAlign={'right'}>{this.formatCurrency(transaction.currency, transaction.amount)}</Text>
        </Td>
        <Td>
        <Button variant={'outline'} size={'xs'}>{transaction.method}</Button>
        </Td>
        <Td>
          <Button
            colorScheme={transaction.status === 'completed' ? 'green' : 'gray'}
            size='xs'
          >
            {transaction.status}
          </Button> 
          {transaction.status === 'pending' && transaction.method === 'card online fygaro' && transaction.data?.url ?
            <a href={transaction.data.url} target="_blank">
              <Button leftIcon={<MdPayment />} colorScheme='green' borderRadius={'full'} size={'xs'}  ml={2} fontSize={'xs'} isDisabled={false}>
                Pay Now
              </Button>
            </a>
            : null
          }

        </Td>

      </Tr>
    );
  }
}

const mapStateToProps = (state: ReduxState) => {
  // const { selectedTransaction, transactionsModals } = state.transactions;
  // return { selectedTransaction, transactionsModals };
  return {}
};

export default connect(mapStateToProps, { 
  // selectTransaction,
  // toggleViewTransactionModal,
  // asyncGeneratePaymentLink
})(TransactionRow);
